'use strict';
require('../widgets/model-action-widget');
require('../widgets/event-visibility-widget');
require('../widgets/visibility-observer');
require('../widgets/modal-container-widget');
require('../widgets/toggle-class-widget');
require('../widgets/input-focus-widget');
require('../widgets/focus-transfer-widget');
require('../widgets/input-validation-widget');
const mmWidgets = require('../widgets/mm-widgets');

module.exports = function pageActionsStart(components, container) {
	Object.keys(components).forEach(componentName => {
		const componentObject = components[componentName];
		mmWidgets('[data-mm-model="' + componentName + '"][data-mm-model-action]').modelActionWidget(componentObject);
		mmWidgets('[data-mm-event-dispatcher~="' + componentName + '"]').eventVisibilityWidget(componentObject);
	});
	mmWidgets('modalContainer')
		.visibilityObserver() //in widgets
		.modalContainerWidget()
		.focusTransferWidget(container);

	mmWidgets('[data-mm-toggle-class]').toggleClassWidget(); //in widgets
	mmWidgets('[data-mm-input-focus]').inputFocusWidget();
	mmWidgets('[data-mm-validate-input]').inputValidationWidget();
};
